import * as actionTypes from '../actions/actionTypes';

const intiData = {
  data: {
    registeredAddress: undefined,
    correspondenceAddress: undefined,
    businessAddress: undefined,
    primaryBusinessContacts: [],
    declarationSignatories: []
  },
  statuses: {
    basicDetails: {status: "incomplete"},
    addresses: {status: "incomplete"},
    primaryBusinessContacts: {status: "incomplete"},
    declarationSignatories: {status: "incomplete"}
  }
};

export default function currentCustomerDetailsReducer(state = intiData, action) {
  switch(action.type){
    case actionTypes.SET_CURRENT_CUSTOMER_DETAILS: {
      let newState = {};
      const statuses = {...state.statuses};
      newState.data = {...state.data, ...action.customerData};
      newState.statuses = statuses;
      return newState;
    }
    case actionTypes.RESET_CURRENT_CUSTOMER_DETAILS: {
      return intiData;
    }
    case actionTypes.SET_CURRENT_CUSTOMER_DETAILS_STATUSES: {
      let newState = {...state};
      newState.statuses = action.statuses;
      return newState;
    }
    case actionTypes.SET_CUSTOMER_DETAIL_ACTIVE_TAB_INDEX: {
      let newState = {...state};
      newState.activeTabIndex = action.index;
      return newState;
    }
    case actionTypes.RESET_CUSTOMER_DETAIL_ACTIVE_TAB_INDEX: {
      let newState = {...state};
      newState.activeTabIndex = 0;
      return newState;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/reducers/currentCustomerDetailsReducer.js